//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CardClient from '../../../clients/robox-api/CardClient.js';
import PurchaseClient from '../../../clients/robox-api/PurchaseClient.js';

import objectIsEmpty from '../../../util/objectIsEmpty.js';
import moneyFormat from '../../../util/moneyFormat.js';

import MySubscriptionsAllOrdersModal from './my-subscriptions/MySubscriptionsAllOrdersModal.vue'

export default  {
    name: 'MySubscriptions',
    components: {
        MySubscriptionsAllOrdersModal,
    },
    props: {
        subscriptions: {
            required: true,
            type: Object,
        },
    },
    data: () => {
        return {
            card: {},
            cards: {},
            purchase: {},
            purchases: {},
        };
    },
    computed: {
        cardsOrderedBySubscription: {
            get: function () {
                const self = this;
                let cardsOrdered = {};

                if (!objectIsEmpty(self.cards)) {
                    self.subscriptions.data.forEach(function (subscription) {
                        cardsOrdered[`subscription_id_${subscription.id}`] = self.cards.data.find((card) => {
                            return subscription.attributes.card_id === card.attributes.id;
                        });
                    });
                }

                return cardsOrdered;
            },
        },
        purchasesOrderedBySubscription: {
            get: function () {
                const self = this;
                let purchasesOrdered = {};

                if (!objectIsEmpty(self.purchases)) {
                    self.subscriptions.data.forEach(function (subscription) {
                        purchasesOrdered[`subscription_id_${subscription.id}`] = self.purchases.data.find((purchase) => {
                            return subscription.attributes.id === purchase.attributes.subscription_id;
                        });
                    });
                }

                return purchasesOrdered;
            },
        },
    },
    filters: {
        formattedMoney: function (amount) {
            return moneyFormat(amount);
        },
        formattedDate: function (date) {
            const time = new Date(date);
            return `${time.getDate()}/${time.getMonth() + 1}/${time.getFullYear()}`;
        },
    },
    methods: {
        objectIsEmpty: function (obj) {
            return objectIsEmpty(obj);
        },
    },
    created () {
        new CardClient()
            .index()
            .then((response) => {
                this.cards = response;
            });
    },
    mounted () {
        new PurchaseClient()
            .index()
            .then((response) => {
                this.purchases = response;
            });
    },
};



// WEBPACK FOOTER //
// ./scripts/vue/components/template-dashboard/MySubscriptions.vue